import { useGenesisCountdown, pad2 } from "@/lib/genesis";

export default function GenesisCountdown() {
    const { days, hours, minutes, seconds } = useGenesisCountdown();
    const cells = [
        [days, "Days"],
        [hours, "Hours"],
        [minutes, "Min"],
        [seconds, "Sec"],
    ];

    return (
        <div
            data-testid="hero-countdown"
            className="inline-flex flex-col gap-4 rounded-lg border border-white/10 bg-white/[0.03] px-5 py-4 backdrop-blur sm:flex-row sm:items-center sm:gap-7"
        >
            <div className="flex items-center gap-2.5">
                <span className="h-1.5 w-1.5 animate-blink rounded-full bg-cyber shadow-[0_0_10px_rgba(0,209,255,0.9)]" />
                <span className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.28em] text-slate-300">
                    Genesis launch
                    <br className="sm:hidden" /> · 28 Oct 2026
                </span>
            </div>
            <div className="flex items-center gap-3.5 sm:gap-4">
                {cells.map(([v, l], i) => (
                    <div key={l} className="flex items-center gap-3.5 sm:gap-4">
                        {i > 0 && (
                            <span className="-mt-3 animate-blink font-mono text-lg text-cyber/60">:</span>
                        )}
                        <div className="text-center">
                            <div className="font-mono text-xl font-semibold tabular-nums text-white drop-shadow-[0_0_12px_rgba(0,209,255,0.35)] sm:text-2xl">
                                {pad2(v)}
                            </div>
                            <div className="mt-0.5 font-mono text-[8px] uppercase tracking-[0.22em] text-slate-500">
                                {l}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
